import { tns } from "../../../node_modules/tiny-slider/src/tiny-slider.module.js"
const overlayFn  = {}
overlayFn.body = document.body;
overlayFn.overlayWrap = document.getElementById('overlay_wrap');
// overlayFn.overlayAllElement = overlayFn.overlayWrap.childNodes;
overlayFn.overlayItem = document.getElementsByClassName('overlay_item');
overlayFn.overlayBox =  document.getElementsByClassName('overlay_box');
overlayFn.overlayClose =  document.getElementsByClassName('overlay_close');
overlayFn.overlayBg =  document.getElementsByClassName('overlay_bg')[0];
overlayFn.noCover = false
overlayFn.init = function (){
	Array.prototype.forEach.call(overlayFn.overlayItem, item => {
		item.addEventListener('click', function(){
			const dataBox = this.getAttribute('data-box-id');
			const dataFull = this.getAttribute('data-full');
			const dataInClose = this.getAttribute('data-inClose');
			const dataInNoCover = this.getAttribute('data-noCover');
			/*
			if(dataInNoCover == 'true'){
				overlayFn.noCover = true
			}
			//*/
			overlayFn.open({box:　dataBox, full: dataFull, inClose: dataInClose, noCover: dataInNoCover});
		});
	})
	overlayFn.overlayWrap.addEventListener('click', function () {
		if(!overlayFn.noCover){
			overlayFn.close()
		}
	})
	Array.prototype.forEach.call(overlayFn.overlayBox, box => {
		box.addEventListener('click', function (e) {
			e.stopPropagation()
		})
	})
	Array.prototype.forEach.call(overlayFn.overlayClose, item => {
		item.addEventListener('click', function () {
			overlayFn.close()
		})
	})
}
overlayFn.open = function(obj){
	overlayFn.close();
	const dataBox = obj.box;
	const dataFull = obj.full;
	const dataInClose = obj.inClose;
	const dataNoCover = obj.noCover;
	const body_w = overlayFn.body.clientWidth;

	if(dataFull == 'true'){
		overlayFn.overlayWrap.classList.add('full');
	}
	if(dataInClose == 'true'){
		overlayFn.overlayWrap.classList.add('in_close');
	}
	if(dataNoCover == 'true'){
		overlayFn.overlayWrap.classList.add('no_cover');
		// overlayFn.noCover = true
	}

	// overlayFn.body.setAttribute('style', 'width: '+ body_w +'px');
	overlayFn.body.classList.add('lock');
	overlayFn.overlayWrap.classList.add('trans');
	if(dataBox != null && dataBox != "" ){
		if(overlayFn.overlayBox.length > 0){
			Array.prototype.forEach.call(overlayFn.overlayBox, box => {
				box.classList.add('hide');
			})
		}
		const thisTa = document.getElementById(dataBox);
		thisTa.classList.remove('hide');
		// tiny slider
		//*
		if(thisTa.className.search('overlay_slider') > 0 ){
			const slider = thisTa.querySelector('.slider');
			const sliderBtnWrap = thisTa.querySelector('.slider_btn_wrap')
			overlayFn.slider = tns({ container: slider, items: 1, slideBy: 'page', autoplay: false, autoplayButtonOutput: false, mouseDrag: true, controlsContainer: sliderBtnWrap, nav: false, speed: 600, rewind: true, });
		}
		/*
		const playerId = thisTa.getAttribute('data-player-id')
		if(!!playerId) {
			setTimeout(function(){
				console.log(window.ytPlayer[playerId])
				window.ytPlayer[playerId].playVideo()
			}, 2000)
		}
		//*/
		
		//*/
		// setTimeout(function(){
		// 	const thisTa_h = document.getElementById(dataBox).clientHeight;
		// 	overlayFn.overlayBg.style.minHeight = thisTa_h + 40 +"px"
		// },100)
		thisTa.classList.add('trans');
	}
}

overlayFn.close = function(){
	overlayFn.body.classList.remove('lock');
	// overlayFn.body.setAttribute('style', '');
	overlayFn.overlayWrap.classList.remove('trans');
	overlayFn.overlayWrap.classList.remove('in_close');
	overlayFn.overlayWrap.classList.remove('no_cover');
	if(overlayFn.overlayBox.length > 0){
		Array.prototype.forEach.call(overlayFn.overlayBox, box => {
			box.classList.remove('trans', 'hide');
		})
	}
	if(overlayFn.slider != null){
		overlayFn.slider.destroy();
		overlayFn.slider = null;
	}
}



overlayFn.notice = function(noticeWord){
	if(noticeWord != undefined && noticeWord != null && noticeWord != ""){

		overlayFn.noticeBox = document.getElementById('notice_box');
		overlayFn.noticeText = document.getElementById('notice_text');
		overlayFn.overlayWrap.classList.add('in_close')
		overlayFn.noticeBox.classList.add('trans');
		
		const body_w = overlayFn.body.clientWidth;
		// overlayFn.body.setAttribute('style', 'width: '+ body_w +'px');
		
		overlayFn.body.classList.add('lock');
		overlayFn.overlayWrap.classList.add('trans');
		// console.log(typeof noticeWord)

		if(overlayFn.overlayBox.length > 0){
			Array.prototype.forEach.call(overlayFn.overlayBox, box => {
				box.classList.add('hide');
			})
		}
		overlayFn.noticeBox.classList.remove('hide');

		if(typeof noticeWord == 'object'){
			overlayFn.noticeText.innerHTML = ""
			Array.prototype.forEach.call(noticeWord, word => {
				const p = document.createElement('p');
				const t = p.innerHTML = noticeWord[i];
				overlayFn.noticeText.appendChild(p)
			})
		}else{
			overlayFn.noticeText.innerHTML = noticeWord;
		}
	}

}


export default overlayFn;


// overlay
// if(document.getElementById('overlay_wrap') != null){
// 	overlayFn();
// }
